var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeModalBarPlace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#009BE2",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3333 38.3333V61.6667C63.3333 62.5871 62.5871 63.3333 61.6666 63.3333H58.3333C57.4128 63.3333 56.6666 62.5871 56.6666 61.6667V38.3333C56.6666 37.4129 57.4128 36.6667 58.3333 36.6667H61.6666C62.5871 36.6667 63.3333 37.4129 63.3333 38.3333ZM53.3333 61.6667V45C53.3333 44.0795 52.5871 43.3333 51.6666 43.3333H48.3333C47.4128 43.3333 46.6666 44.0795 46.6666 45V61.6667C46.6666 62.5871 47.4128 63.3333 48.3333 63.3333H51.6666C52.5871 63.3333 53.3333 62.5871 53.3333 61.6667ZM41.6666 63.3333H38.3333C37.4128 63.3333 36.6666 62.5871 36.6666 61.6667V51.6667C36.6666 50.7462 37.4128 50 38.3333 50H41.6666C42.5871 50 43.3333 50.7462 43.3333 51.6667V61.6667C43.3333 62.5871 42.5871 63.3333 41.6666 63.3333Z",
    fill: "#009BE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeModalBarPlace);
export default __webpack_public_path__ + "static/media/welcome-modal-bar-place.c6c8c4f3e67c7c3990f8ba6eb64efc88.svg";
export { ForwardRef as ReactComponent };